<div class="lvi-content">
    <div class="avatar">
        <i class="material-icons-outlined">business</i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a class="label" (click)="onItemClick()">{{ data.raisonSociale }}</a>
        </div>
        <ul class="lvi-attrs">
            <li *ngIf="data.codeFournisseur"><strong [translate]="'admin.frais.fournisseurs.code'"></strong> {{ data.codeFournisseur }} </li>
            <li *ngIf="data.devise"><strong [translate]="'admin.frais.fournisseurs.devise'"></strong> {{ data.devise }} </li>
            <li *ngIf="data.orga?.libelle"><strong [translate]="'admin.frais.fournisseurs.service'"></strong> {{ data.orga.libelle }} </li>
            <li *ngIf="data.actif !== undefined"><strong [translate]="'admin.frais.fournisseurs.actif'"></strong> {{ (data.actif ? 'global.oui' : 'global.non') | translate }} </li>
        </ul>
    </div>
</div>